import React from "react";
import { SortableListValues, ObjectListValues } from "../";

export const ObjectListColors = (props) => <ObjectListValues {...props} editText="Editar color" addText="Agregar color" SortableList={SortableListValues} />
